/**
 * マッチング設定一覧ページ（Presentation）
 */
import type { FC } from "react";
import { Link } from "react-router-dom";
import type { MatchingSetting } from "../../../hooks/use-matching-settings-api";
import { MatchingSettingsTable } from "./MatchingSettingsTable";

type MatchingSettingsPageProps = {
  settings: MatchingSetting[];
  loading: boolean;
  error: { message: string } | null;
  onActivate: (settingId: string) => Promise<void>;
  onDeactivate: (settingId: string) => Promise<void>;
  onDelete: (settingId: string) => Promise<void>;
  isActivating: boolean;
  isDeleting: boolean;
};

export const MatchingSettingsPage: FC<MatchingSettingsPageProps> = ({
  settings,
  loading,
  error,
  onActivate,
  onDeactivate,
  onDelete,
  isActivating,
  isDeleting,
}) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold">マッチング条件設定</h1>
          <p className="text-base-content/60 mt-1">
            マッチングの条件やモードを管理できます
          </p>
        </div>
        <Link
          to="/settings/matching/conditions/new"
          className="btn btn-primary btn-sm"
        >
          + 新規作成
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <span className="loading loading-spinner loading-lg" />
        </div>
      ) : error ? (
        <div className="alert alert-error">
          <span>{error.message}</span>
        </div>
      ) : (
        <MatchingSettingsTable
          settings={settings}
          onActivate={onActivate}
          onDeactivate={onDeactivate}
          onDelete={onDelete}
          isActivating={isActivating}
          isDeleting={isDeleting}
        />
      )}
    </div>
  );
};
